import styled from '@emotion/styled';
import React, { Component } from 'react';

import { layoutDeprecatedWarning } from '../../console-messages';
import type { ResponsiveType } from '../../types';
import { getSize, getAlignmentStyles } from '../../utilities';

const alignments = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

const LayoutWrapper = styled.div<LayoutProps>`
  display: flex;
  ${props => getAlignmentStyles(props.alignment, alignments)};

  & > * + * {
    ${props => props.gap && getSize('margin-left', props.gap)};
  }
`;

const LayoutSectionWrapper = styled.div<LayoutSectionProps>`
  min-width: 0px;
  flex-shrink: 0;
  ${props => getSize('width', props.width)};
  ${props => getSize('max-width', props.maxWidth)};
  ${props => (props.width ? `flex-shrink: 0` : `flex: 1 1 0%`)};
`;

export const LayoutSection = ({
  width,
  maxWidth,
  children,
  ...props
}: LayoutSectionProps & React.ComponentProps<typeof LayoutSectionWrapper>) => {
  // eslint-disable-next-line no-console
  console.warn(layoutDeprecatedWarning);

  return (
    <LayoutSectionWrapper width={width} maxWidth={maxWidth} {...props}>
      {children}
    </LayoutSectionWrapper>
  );
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class Layout extends Component<LayoutProps> {
  static Section = LayoutSection;

  render() {
    // eslint-disable-next-line no-console
    console.warn(layoutDeprecatedWarning);

    return <LayoutWrapper {...this.props}>{this.props.children}</LayoutWrapper>;
  }
}

type Alignments = 'start' | 'center' | 'end' | 'stretch';
type LayoutProps = {
  alignment?: Alignments | Alignments[];
  gap?: ResponsiveType<string | number>;
  children?: React.ReactNode;
};

type LayoutSectionProps = {
  width?: ResponsiveType<string | number>;
  maxWidth?: ResponsiveType<string | number>;
  children?: React.ReactNode;
};

export default Layout;
